import { useState } from 'react';
import { useEmployee } from './EmployeeContext';
import { employeeApi } from '../../lib/api';
import { errorMessage } from '../../components/ErrorModalBody';
import { PinBoxInput } from '../../components/PinBoxInput';

export function AlterarPinForm({ onDone }: { onDone?: () => void }) {
  const { refresh } = useEmployee();
  const [novoPin, setNovoPin] = useState('');
  const [novoPin2, setNovoPin2] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState(false);

  async function trocar() {
    setError(''); setOk(false);
    if (!/^\d{4}$/.test(novoPin)) { setError('O novo PIN precisa ter exatamente 4 dígitos.'); return; }
    if (novoPin !== novoPin2) { setError('Os dois PINs digitados são diferentes.'); return; }
    setBusy(true);
    try {
      await employeeApi.changePin(novoPin);
      await refresh();
      setNovoPin(''); setNovoPin2('');
      setOk(true);
      onDone?.();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <label>Novo PIN (4 dígitos)</label>
      <PinBoxInput value={novoPin} onChange={setNovoPin} />
      <label>Confirme o novo PIN</label>
      <PinBoxInput value={novoPin2} onChange={setNovoPin2} onEnter={trocar} />
      {error && <div className="err">{error}</div>}
      {ok && <div className="pill pill-ok" style={{ marginTop: 8 }}>Senha trocada ✓</div>}
      <button className="btn btn-primary btn-block" style={{ marginTop: 10 }} disabled={busy} onClick={trocar}>Confirmar troca</button>
    </>
  );
}
